import { Crosshair, Shield, ClipboardCheck, Wrench } from "lucide-react";
import { Reveal } from "./Reveal";

const ITEMS = [
    { icon: Crosshair, title: "Precision", sub: "Automotive craftsmanship" },
    { icon: Shield, title: "Protection", sub: "Built around your vehicle" },
    { icon: ClipboardCheck, title: "Inspection", sub: "Know what your car needs" },
    { icon: Wrench, title: "Craft", sub: "Detail-driven execution" },
];

export const TrustStrip = () => (
    <div className="border-b border-rz-steel/60 bg-rz-carbon" data-testid="trust-strip">
        <div className="mx-auto grid max-w-[1440px] grid-cols-2 lg:grid-cols-4">
            {ITEMS.map((it, i) => (
                <Reveal
                    key={it.title}
                    delay={i * 0.06}
                    className={`flex items-center gap-4 px-6 py-6 sm:px-8 ${
                        i % 2 === 0 ? "border-r border-rz-steel/60" : ""
                    } ${i < 2 ? "border-b border-rz-steel/60 lg:border-b-0" : ""} ${
                        i < 3 ? "lg:border-r lg:border-rz-steel/60" : ""
                    }`}
                >
                    <it.icon size={20} strokeWidth={1.5} className="shrink-0 text-rz-red" />
                    <div>
                        <p className="font-display text-[13px] font-bold uppercase tracking-[0.18em] text-rz-white">
                            {it.title}
                        </p>
                        <p className="mt-0.5 text-[12px] text-rz-smoke">{it.sub}</p>
                    </div>
                </Reveal>
            ))}
        </div>
    </div>
);
